{
  "marketplace.action.addAnother": "Add another",
  "marketplace.action.install": "Install",
  "marketplace.action.installing": "Installing…",
  "marketplace.action.manage": "Manage",
  "marketplace.action.purchase": "Purchase",
  "marketplace.action.purchaseAndInstall": "Purchase & Install",
  "marketplace.action.remove": "Remove",
  "marketplace.action.subscribe": "Subscribe",
  "marketplace.action.uninstall": "Uninstall",
  "marketplace.action.use": "Use",
  "marketplace.app.assistantsApp.name": "Assistants",
  "marketplace.app.biApp.name": "Insights",
  "marketplace.app.bookmarksApp.name": "Bookmarks",
  "marketplace.app.capTableApp.name": "Cap Table",
  "marketplace.app.catalogApp.name": "Products",
  "marketplace.app.cmsApp.name": "Content",
  "marketplace.app.commerceApp.name": "Commerce",
  "marketplace.app.crmApp.name": "CRM",
  "marketplace.app.excalidraw.name": "Excalidraw",
  "marketplace.app.gazerApp.name": "Gazer",
  "marketplace.app.helmetApp.name": "SEO",
  "marketplace.app.hrApp.name": "People",
  "marketplace.app.insuranceApp.name": "Insurance",
  "marketplace.app.invoicesApp.name": "Invoices",
  "marketplace.app.jobsApp.name": "Hiring",
  "marketplace.app.ordersApp.name": "Orders",
  "marketplace.app.payrollApp.name": "Payroll",
  "marketplace.app.policiesManagementApp.name": "Insurance Policy Dashboard",
  "marketplace.app.polyglotApp.name": "Translations",
  "marketplace.app.productionApp.name": "Production",
  "marketplace.app.realestateApp.name": "Real estate",
  "marketplace.app.schedulingApp.name": "Scheduling",
  "marketplace.app.socialsApp.name": "Socials",
  "marketplace.app.terminalApp.name": "Terminal",
  "marketplace.app.warehouseApp.name": "Inventory",
  "marketplace.appStore.categoryAll": "All",
  "marketplace.appStore.overview": "Overview",
  "marketplace.appStore.features": "Features",
  "marketplace.appStore.access": "What it can access",
  "marketplace.appStore.accessLoading": "Reading the app's permissions…",
  "marketplace.appStore.accessNone": "This app reads and writes no workspace records.",
  "marketplace.appStore.accessOwns": "Reads and writes",
  "marketplace.appStore.accessReads": "Reads only",
  "marketplace.appStore.accessActions": "Adds assistant actions",
  "marketplace.appStore.accessNav": "Adds to navigation",
  "marketplace.appStore.accessNotifyRoles": "Notifies members by role",
  "marketplace.appStore.accessNotifyPermissions": "Notifies members by permission",
  "marketplace.appStore.accessNotifyTeams": "Notifies teams",
  "marketplace.appStore.details": "Details",
  "marketplace.appStore.detailVersion": "Version",
  "marketplace.appStore.detailUpdated": "Updated",
  "marketplace.appStore.detailCategory": "Category",
  "marketplace.appStore.detailInstalls": "Installs",
  "marketplace.appStore.detailPublisher": "Publisher",
  "marketplace.appStore.detailLanguages": "Languages",
  "marketplace.appStore.detailWebsite": "Website",
  "marketplace.appStore.detailSupport": "Support",
  "marketplace.appStore.sortBy": "Sort by",
  "marketplace.appStore.sortPopular": "Popular",
  "marketplace.appStore.sortNewest": "Newest",
  "marketplace.appStore.sortName": "Name A–Z",
  "marketplace.appStore.pin": "Pin this app",
  "marketplace.appStore.unpin": "Unpin this app",
  "marketplace.appStore.widgets": "Widgets",
  "marketplace.appStore.widgetSizeS": "S",
  "marketplace.appStore.widgetSizeM": "M",
  "marketplace.appStore.widgetSizeL": "L",
  "marketplace.appStore.widgetSizeXL": "XL",
  "marketplace.card.byAuthor": "by {owner}",
  "marketplace.card.pin": "Pin to sidebar",
  "marketplace.card.pinAria": "Toggle pin",
  "marketplace.card.tools": "{count} tools",
  "marketplace.card.toolsOne": "{count} tool",
  "marketplace.card.forks": "{count} forks",
  "marketplace.card.forksOne": "{count} fork",
  "marketplace.category.ai": "AI",
  "marketplace.category.analytics": "Analytics",
  "marketplace.category.auth": "Auth",
  "marketplace.category.automation": "Automation",
  "marketplace.category.backend": "Backend",
  "marketplace.category.catalog": "Catalog",
  "marketplace.category.cms": "CMS",
  "marketplace.category.commerce": "Commerce",
  "marketplace.category.content": "Content",
  "marketplace.category.crm": "CRM",
  "marketplace.category.database": "Database",
  "marketplace.category.docs": "Docs",
  "marketplace.category.domains": "Domains",
  "marketplace.category.editor": "Editor",
  "marketplace.category.finance": "Finance",
  "marketplace.category.hr": "HR",
  "marketplace.category.i18n": "i18n",
  "marketplace.category.insurance": "Insurance",
  "marketplace.category.inventory": "Inventory",
  "marketplace.category.jobs": "Jobs",
  "marketplace.category.marketing": "Marketing",
  "marketplace.category.messaging": "Messaging",
  "marketplace.category.observability": "Observability",
  "marketplace.category.payments": "Payments",
  "marketplace.category.quality": "Quality",
  "marketplace.category.scheduling": "Scheduling",
  "marketplace.category.seo": "SEO",
  "marketplace.category.starter": "Starter",
  "marketplace.category.storage": "Storage",
  "marketplace.category.system": "System",
  "marketplace.category.ui": "UI",
  "marketplace.chip.kind": "Kind: {kind}",
  "marketplace.chip.removeAria": "Remove filter {label}",
  "marketplace.composer.cancel": "Cancel",
  "marketplace.composer.messageLabel": "MESSAGE (OPTIONAL)",
  "marketplace.composer.messagePlaceholder": "Tell the community what you built…",
  "marketplace.composer.pickProject": "Select a public project…",
  "marketplace.composer.projectLabel": "PROJECT",
  "marketplace.composer.title": "Share a project",
  "marketplace.composer.post": "Post",
  "marketplace.composer.posting": "Posting…",
  "marketplace.composer.selectProject": "Select a project to share.",
  "marketplace.composer.shareFailed": "Failed to share post.",
  "marketplace.copyLink.copied": "Copied!",
  "marketplace.copyLink.label": "Copy link",
  "marketplace.copyLink.tooltip": "Copy a link that reproduces this filtered view",
  "marketplace.detail.closeAria": "Close detail",
  "marketplace.detail.ctaAttachLibrary": "Attach library",
  "marketplace.detail.ctaConnect": "Connect",
  "marketplace.detail.ctaConnectMcp": "Connect MCP",
  "marketplace.detail.ctaConnectRegistrar": "Connect registrar",
  "marketplace.detail.ctaCopyAgent": "Copy agent",
  "marketplace.detail.ctaCopyPrompt": "Copy prompt",
  "marketplace.detail.ctaCopySkill": "Copy skill",
  "marketplace.detail.ctaInstallAgent": "Install agent",
  "marketplace.detail.ctaInstallPlugin": "Install plugin",
  "marketplace.detail.ctaInstallSkill": "Install skill",
  "marketplace.detail.ctaUseTemplate": "Use as template",
  "marketplace.detail.fork": "Fork",
  "marketplace.detail.forkedAs": "Forked as “{name}” — private to your workspace.",
  "marketplace.detail.forking": "Forking…",
  "marketplace.detail.forks": "{count} forks",
  "marketplace.detail.forksOne": "1 fork",
  "marketplace.detail.installs": "{count} installs",
  "marketplace.detail.installsOne": "1 install",
  "marketplace.detail.metaAuth": "Auth",
  "marketplace.detail.metaAuthor": "Author",
  "marketplace.detail.metaBestWith": "Best with",
  "marketplace.detail.metaCategory": "Category",
  "marketplace.detail.metaDefaultScope": "Default scope",
  "marketplace.detail.metaInstalls": "Installs",
  "marketplace.detail.metaInstallsInto": "Installs into",
  "marketplace.detail.metaModel": "Model",
  "marketplace.detail.metaMultiInstance": "Multi-instance",
  "marketplace.detail.metaPrice": "Price",
  "marketplace.detail.metaTokens": "Tokens",
  "marketplace.detail.metaTools": "Tools",
  "marketplace.detail.metaTransport": "Transport",
  "marketplace.detail.metaTrigger": "Trigger",
  "marketplace.detail.metaUpdated": "Updated",
  "marketplace.detail.metaVersion": "Version",
  "marketplace.detail.noDescription": "No description.",
  "marketplace.detail.openFork": "Open the fork",
  "marketplace.detail.reuses": "{count} reuses",
  "marketplace.detail.reusesOne": "1 reuse",
  "marketplace.detail.tabGallery": "Gallery",
  "marketplace.detail.tabLive": "Live",
  "marketplace.detail.uses": "{count} uses",
  "marketplace.detail.usesOne": "1 use",
  "marketplace.detail.valueFree": "Free",
  "marketplace.detail.valueWorkspace": "Workspace",
  "marketplace.detail.valueYes": "Yes",
  "marketplace.detail.forkFailed": "Fork failed — please try again.",
  "marketplace.detail.forkUnsupported": "Fork is not supported by this SDK version — please reload.",
  "marketplace.detail.forkNoSource": "This listing has no source project to fork.",
  "marketplace.detail.skillInstall": "**Install:** save the markdown above as {path}.",
  "marketplace.dialog.installMessage": "Adds its pages, widgets and navbar entries to this workspace — visible to everyone with access to it.",
  "marketplace.dialog.installMessageNamed": "Adds its pages, widgets and navbar entries to \"{workspace}\" — visible to everyone with access to that workspace.",
  "marketplace.dialog.installTitle": "Install {name}?",
  "marketplace.dialog.removeMessage": "This removes its pages, widgets and navbar entries from your workspace. Your content stays and reappears if you reinstall.",
  "marketplace.dialog.removeTitle": "Remove {name}?",
  "marketplace.empty.hint": "Try a different search, choose another category, or reset your filters to browse everything here.",
  "marketplace.empty.installedHint": "No installed items match this view. Reset your filters to discover items you can add.",
  "marketplace.empty.installedTitle": "Nothing installed yet",
  "marketplace.empty.queryTitle": "No matches for \"{query}\"",
  "marketplace.empty.reset": "Reset filters",
  "marketplace.empty.title": "No items match your filters",
  "marketplace.empty.loadingTitle": "Loading apps…",
  "marketplace.empty.loadingHint": "Your workspace app catalog is on its way.",
  "marketplace.empty.errorTitle": "Apps couldn’t load",
  "marketplace.empty.errorHint": "Try loading the catalog again. Your filters will stay in place.",
  "marketplace.empty.retry": "Try again",
  "marketplace.error.forceRemoveRetry": "Failed to force-remove — please try again.",
  "marketplace.error.installFailed": "Install failed",
  "marketplace.error.installFailedRetry": "Install failed. Please try again.",
  "marketplace.error.installRetry": "Install failed — please try again.",
  "marketplace.error.removeFailed": "Failed to remove app",
  "marketplace.error.tryAgain": "Please try again.",
  "marketplace.error.unexpected": "Unexpected error.",
  "marketplace.error.connectorUrlRequired": "Server URL is required.",
  "marketplace.error.connectorNoWorkspace": "No active workspace to install the connector into.",
  "marketplace.error.connectorCreateFailed": "Failed to create connector.",
  "marketplace.error.capabilityNoOrg": "Not signed in to an organization.",
  "marketplace.error.capabilityFailed": "The action failed. Please try again.",
  "marketplace.featuredToday.eyebrow": "Featured today",
  "marketplace.featuredToday.kindFallback": "Featured",
  "marketplace.feed.emptyHint": "Be the first to share a project. Click \"Share a project\" to post one of your public projects to the feed.",
  "marketplace.feed.emptyTitle": "No posts yet",
  "marketplace.feed.eyebrow": "Community",
  "marketplace.feed.loadError": "Could not load the feed. Your posts are safe — try again.",
  "marketplace.feed.retry": "Retry",
  "marketplace.feed.share": "Share a project",
  "marketplace.feed.title": "Feed",
  "marketplace.feedPost.comment": "Comment",
  "marketplace.feedPost.commentPlaceholder": "Add a comment…",
  "marketplace.feedPost.like": "Like",
  "marketplace.feedPost.noComments": "No comments yet — be the first.",
  "marketplace.feedPost.reply": "Reply",
  "marketplace.feedPost.viewProject": "View project →",
  "marketplace.feedPost.untitledProject": "Untitled project",
  "marketplace.feedSeed.communityAuthorTitle": "From the team",
  "marketplace.feedSeed.communityDescr": "A landing-page template the community helps maintain.",
  "marketplace.feedSeed.communityMessage": "Welcome to the marketplace feed. Share what you build and follow people whose work you want to see more of.",
  "marketplace.feedSeed.starterAuthorTitle": "Building Symbols",
  "marketplace.feedSeed.starterDescr": "Tokens, typography, and a 12-column scale.",
  "marketplace.feedSeed.starterMessage": "Just shipped a starter that wires Symbols design tokens into a clean component scale. Drop in and customize.",
  "marketplace.feedSidebar.aria": "Feed",
  "marketplace.feedSidebar.feedHead": "FEED",
  "marketplace.feedSidebar.filterAll": "All",
  "marketplace.feedSidebar.filterFollowing": "Following",
  "marketplace.feedSidebar.filterRecent": "Recent",
  "marketplace.feedSidebar.followHead": "WHO TO FOLLOW",
  "marketplace.feedSidebar.noSuggestions": "No suggestions yet",
  "marketplace.feedSidebar.templateAuthor": "Template author",
  "marketplace.filters.allKinds": "All kinds",
  "marketplace.filters.anyCategory": "Any category",
  "marketplace.filters.clear": "Clear",
  "marketplace.filters.done": "Done",
  "marketplace.filters.groupCategories": "Categories",
  "marketplace.filters.groupKind": "Kind",
  "marketplace.filters.groupPricing": "Pricing",
  "marketplace.filters.groupSort": "Sort",
  "marketplace.filters.sortName": "Name (A–Z)",
  "marketplace.filters.sortPopular": "Most popular",
  "marketplace.filters.sortRecent": "Recently added",
  "marketplace.gallery.comingSoon": "Screenshots coming soon",
  "marketplace.gallery.next": "Next",
  "marketplace.gallery.nextAria": "Next screenshot",
  "marketplace.gallery.prev": "Previous",
  "marketplace.gallery.prevAria": "Previous screenshot",
  "marketplace.gallery.thumb": "Screenshot {n}",
  "marketplace.hero.appStoreSubtitle": "Apps that install into your workspace — data, content, and operations in one place.",
  "marketplace.hero.appStoreTitle": "App Store",
  "marketplace.hero.integrationsSubtitle": "Service connectors — the accounts and APIs your workspace can talk to.",
  "marketplace.hero.integrationsTitle": "Integrations",
  "marketplace.install.back": "← Back",
  "marketplace.install.cancel": "Cancel",
  "marketplace.install.closeAria": "Close install modal",
  "marketplace.install.configureTitle": "Configure {name}",
  "marketplace.install.displayName": "Display name",
  "marketplace.install.displayNamePlaceholder": "My integration",
  "marketplace.install.genericIntegration": "integration",
  "marketplace.install.next": "Next: Configure →",
  "marketplace.install.noConfig": "No configuration required. Click Install to complete the setup.",
  "marketplace.install.noOrg": "You need an organisation before installing integrations. Create one in your account settings.",
  "marketplace.install.noProjects": "No projects found. You can install at workspace level.",
  "marketplace.install.noWorkspaces": "No workspaces found in this org.",
  "marketplace.install.preview": "👁 Preview",
  "marketplace.install.previewAria": "Open preview",
  "marketplace.install.previewTooltip": "Preview",
  "marketplace.install.scopeHint": "Choose the org, workspace, and optionally a project to scope this integration.",
  "marketplace.install.scopeHintApp": "Workspace apps install directly into a workspace — pick which one below.",
  "marketplace.install.scopeOrg": "Org",
  "marketplace.install.scopeProject": "Project (optional)",
  "marketplace.install.scopeTitle": "Where should this integration be installed?",
  "marketplace.install.scopeTitleApp": "Which workspace should this app install into?",
  "marketplace.install.scopeWorkspace": "Workspace",
  "marketplace.install.secretLabel": "API key / Secret",
  "marketplace.install.selectProject": "Select project (optional)",
  "marketplace.install.selectWorkspace": "Select workspace",
  "marketplace.install.selectWorkspaceFirst": "Select a workspace before installing a paid integration.",
  "marketplace.install.stepChooseWorkspace": "Choose workspace",
  "marketplace.install.stepConfigure": "Configure",
  "marketplace.install.stepError": "Catalog error",
  "marketplace.install.stepOneOfTwo": "Step 1 of 2: Select scope",
  "marketplace.install.stepTwoOfTwo": "Step 2 of 2: Configure",
  "marketplace.install.title": "Install {name}",
  "marketplace.install.errorNoOrg": "No active organisation. Please sign in.",
  "marketplace.install.fieldRequired": "\"{field}\" is required.",
  "marketplace.install.workspaceIdRequired": "Select or enter a workspace ID.",
  "marketplace.install.projectIdRequired": "Select or enter a project ID.",
  "marketplace.install.wrongCategory": "This item is in the \"{category}\" category, not \"{required}\".",
  "marketplace.install.wrongTypes": "This item does not apply to the required type(s): {types}.",
  "marketplace.install.wrongScopes": "This item does not apply to the required scope(s): {scopes}.",
  "marketplace.install.kindNotInCatalogue": "\"{kind}\" is not available in the current catalogue. See /admin-integration-kinds if you need to add it.",
  "marketplace.install.mcpConnector": "MCP connector",
  "marketplace.installDeps.cancel": "Cancel",
  "marketplace.installDeps.checkAria": "Install {name} alongside this app",
  "marketplace.installDeps.hint": "{name} works with {count} other apps already in the App Store. Choose what to install alongside it.",
  "marketplace.installDeps.hintOne": "{name} works with 1 other app already in the App Store. Choose what to install alongside it.",
  "marketplace.installDeps.optional": "Optional",
  "marketplace.installDeps.required": "Required",
  "marketplace.installDeps.requiredTooltip": "Required — always installed with this app",
  "marketplace.installDeps.submit": "Install {count} apps",
  "marketplace.installDeps.submitOne": "Install 1 app",
  "marketplace.installDeps.thisApp": "this app",
  "marketplace.installDeps.thisAppCap": "This app",
  "marketplace.installDeps.title": "Install {name}?",
  "marketplace.integrations.count": "{count} integrations",
  "marketplace.integrations.countOne": "1 integration",
  "marketplace.integrations.installs": "{count} installs",
  "marketplace.integrations.installsOne": "1 install",
  "marketplace.integrations.title": "Integrations",
  "marketplace.island.searchPlaceholder": "Search apps, templates, integrations…",
  "marketplace.kind.agent.many": "Agents",
  "marketplace.kind.agent.noun": "agent",
  "marketplace.kind.agent.nouns": "agents",
  "marketplace.kind.agent.one": "Agent",
  "marketplace.kind.app.many": "Workspace apps",
  "marketplace.kind.app.noun": "app",
  "marketplace.kind.app.nouns": "apps",
  "marketplace.kind.app.one": "Workspace app",
  "marketplace.kind.integration.many": "Integrations",
  "marketplace.kind.integration.noun": "integration",
  "marketplace.kind.integration.nouns": "integrations",
  "marketplace.kind.integration.one": "Integration",
  "marketplace.kind.library.many": "Libraries",
  "marketplace.kind.library.noun": "library",
  "marketplace.kind.library.nouns": "libraries",
  "marketplace.kind.library.one": "Library",
  "marketplace.kind.mcp.many": "MCP servers",
  "marketplace.kind.mcp.noun": "MCP server",
  "marketplace.kind.mcp.nouns": "MCP servers",
  "marketplace.kind.mcp.one": "MCP server",
  "marketplace.kind.plugin.many": "Plugins",
  "marketplace.kind.plugin.noun": "plugin",
  "marketplace.kind.plugin.nouns": "plugins",
  "marketplace.kind.plugin.one": "Plugin",
  "marketplace.kind.prompt.many": "Prompts",
  "marketplace.kind.prompt.noun": "prompt",
  "marketplace.kind.prompt.nouns": "prompts",
  "marketplace.kind.prompt.one": "Prompt",
  "marketplace.kind.registrar.many": "Domain registrars",
  "marketplace.kind.registrar.noun": "registrar",
  "marketplace.kind.registrar.nouns": "registrars",
  "marketplace.kind.registrar.one": "Domain registrar",
  "marketplace.kind.skill.many": "Skills",
  "marketplace.kind.skill.noun": "skill",
  "marketplace.kind.skill.nouns": "skills",
  "marketplace.kind.skill.one": "Skill",
  "marketplace.kind.template.many": "Templates",
  "marketplace.kind.template.noun": "template",
  "marketplace.kind.template.nouns": "templates",
  "marketplace.kind.template.one": "Template",
  "marketplace.kindRail.countLibraries": "{count} libraries",
  "marketplace.kindRail.countLibrariesOne": "1 library",
  "marketplace.kindRail.countTemplates": "{count} templates",
  "marketplace.kindRail.countTemplatesOne": "1 template",
  "marketplace.kindRail.featuredTemplates": "Featured templates",
  "marketplace.kindRail.librariesTitle": "Libraries",
  "marketplace.kindRail.seeAll": "See All ›",
  "marketplace.kindRail.showLess": "Show less",
  "marketplace.kindRail.templatesTitle": "Browse templates",
  "marketplace.lazyPage.error": "Couldn’t load this page. Refresh to try again.",
  "marketplace.liveView.devNotice": "Local dev preview — requires a running dev server for this project (portless). A blank or \"Not Found\" page here means the target isn't running locally right now.",
  "marketplace.liveView.linkDirect": "↗ Direct",
  "marketplace.liveView.linkDirectTitle": "Open the published site in a new tab",
  "marketplace.liveView.linkPreview": "↗ Preview",
  "marketplace.liveView.linkPreviewTitle": "Open in preview.symbols.app",
  "marketplace.liveView.linkWorkspace": "↗ Workspace",
  "marketplace.liveView.linkWorkspaceTitle": "Open in my.symbols.app",
  "marketplace.navbar.browse": "Browse",
  "marketplace.navbar.feed": "Feed",
  "marketplace.navbar.searchPlaceholder": "Search posts, authors, projects…",
  "marketplace.navbar.title": "Marketplace",
  "marketplace.page.feedTitle": "Community feed / Marketplace",
  "marketplace.page.storeTitle": "App Store & Marketplace",
  "marketplace.preset.rowTitle": "Workspace presets",
  "marketplace.preset.rowHint": "Start from your industry. A preset adds the apps, channels and folders your work needs.",
  "marketplace.preset.cardAction": "Open the {name} preset",
  "marketplace.preset.cardApply": "Apply",
  "marketplace.preset.cardView": "View",
  "marketplace.preset.appliedMark": "Applied",
  "marketplace.preset.eyebrow": "Workspace preset",
  "marketplace.preset.appsLabel": "Apps",
  "marketplace.preset.setupLabel": "Also sets up",
  "marketplace.preset.setupChannels": "Channels: {list}",
  "marketplace.preset.setupFolders": "Folders: {list}",
  "marketplace.preset.appInstalled": "Installed",
  "marketplace.preset.appSuggested": "Suggested",
  "marketplace.preset.appCheckAria": "Add {name}",
  "marketplace.preset.comingSoon": "{count} more apps are coming soon",
  "marketplace.preset.comingSoonOne": "One more app is coming soon",
  "marketplace.preset.apply": "Apply to {workspace}",
  "marketplace.preset.applyNoName": "Apply to this workspace",
  "marketplace.preset.applyAgain": "Add what is missing",
  "marketplace.preset.applying": "Applying…",
  "marketplace.preset.notNow": "Not now",
  "marketplace.preset.openApp": "Open {name}",
  "marketplace.preset.appliedOn": "Applied {date}",
  "marketplace.preset.askAdmin": "Ask an admin of {workspace} to apply it.",
  "marketplace.preset.askAdminNoName": "Ask an admin of this workspace to apply it.",
  "marketplace.preset.noWorkspace": "Open your workspace to apply this preset.",
  "marketplace.preset.unavailable": "This preset is not available right now.",
  "marketplace.preset.loadFailed": "The presets could not load.",
  "marketplace.preset.progressTitle": "Setting up",
  "marketplace.preset.linePending": "Installing…",
  "marketplace.preset.lineInstalled": "Installed",
  "marketplace.preset.lineSkipped": "Already there",
  "marketplace.preset.lineComingSoon": "Coming soon",
  "marketplace.preset.lineFailed": "Could not install",
  "marketplace.preset.setupReady": "Channels and folders are ready",
  "marketplace.preset.doneLine": "Your workspace is set up for {name}.",
  "marketplace.preset.errorForbidden": "Only a workspace owner or admin can apply a preset.",
  "marketplace.preset.errorFailed": "The preset could not be applied.",
  "marketplace.preset.errorOffline": "Your connection dropped. The preset could not be applied.",
  "marketplace.preset.errorServer": "The server did not answer. The preset could not be applied.",
  "marketplace.preset.busy": "Another preset is being applied. You can apply this one when it finishes.",
  "marketplace.preset.close": "Close",
  "marketplace.preset.tryAgain": "Try again",
  "marketplace.preset.donePartial": "Part of {name} is set up. Try again to add the rest.",
  "marketplace.preset.setupFailed": "{count} channels or folders could not be set up",
  "marketplace.preset.setupFailedOne": "One channel or folder could not be set up",
  "marketplace.preset.virtualAssistance.name": "Virtual assistance (VA)",
  "marketplace.preset.virtualAssistance.line": "Track client work, send invoices and run payroll for your assistants.",
  "marketplace.preset.virtualAssistance.summary": "Everything a virtual assistance team runs on: a board for each client's work, invoices, payroll for your assistants, scheduling and insights.",
  "marketplace.preset.realEstate.name": "Real estate",
  "marketplace.preset.realEstate.line": "Publish listings, book viewings and keep every client and deal in one place.",
  "marketplace.preset.realEstate.summary": "List your properties, book viewings, follow every buyer and deal in the CRM, run your website's content and see how sales are going.",
  "marketplace.preset.ecommerce.name": "E-commerce",
  "marketplace.preset.ecommerce.line": "Sell online, with products, orders, stock and customers in one workspace.",
  "marketplace.preset.ecommerce.summary": "Put your products online, take orders and payments, keep stock in check, know your customers and see what sells.",
  "marketplace.preset.hospitality.name": "Hospitality",
  "marketplace.preset.hospitality.line": "Take bookings, know your guests and run your team and website.",
  "marketplace.preset.medical.name": "Medical",
  "marketplace.preset.medical.line": "Book patient visits and keep every patient record in one place.",
  "marketplace.preset.finance.name": "Finance",
  "marketplace.preset.finance.line": "Follow clients and investors, keep your cap table and see the numbers.",
  "marketplace.preset.education.name": "Education",
  "marketplace.preset.education.line": "Schedule classes, follow every student and run your school website.",
  "marketplace.preset.logistics.name": "Logistics",
  "marketplace.preset.logistics.line": "Book dock slots, keep stock in check and follow every carrier.",
  "marketplace.preset.manufacturing.name": "Manufacturing",
  "marketplace.preset.manufacturing.line": "Keep stock in check, run your team and follow every client.",
  "marketplace.preset.media.name": "Media & creative",
  "marketplace.preset.media.line": "Publish content, follow every client and book client meetings.",
  "marketplace.preset.services.name": "Services",
  "marketplace.preset.services.line": "Follow every client, book meetings and see how the business goes.",
  "marketplace.preset.agro.name": "Agro",
  "marketplace.preset.agro.line": "Keep harvest and stock in check, run your crews and follow every buyer.",
  "marketplace.preset.aerial.name": "Aerial",
  "marketplace.preset.aerial.line": "Schedule missions, run your pilots and keep equipment in check.",
  "marketplace.pricing.all": "Any pricing",
  "marketplace.pricing.free": "Free",
  "marketplace.pricing.installed": "Installed",
  "marketplace.pricing.paid": "Paid",
  "marketplace.pricing.pinned": "Pinned",
  "marketplace.promptCard.chars": "{count} chars",
  "marketplace.promptCard.charsOne": "1 char",
  "marketplace.promptCard.copied": "Copied!",
  "marketplace.promptCard.copy": "Copy prompt",
  "marketplace.promptCard.copyTooltip": "Copy prompt to clipboard",
  "marketplace.prompts.catAll": "All",
  "marketplace.prompts.catComponents": "Components",
  "marketplace.prompts.catDebugging": "Debugging",
  "marketplace.prompts.catDesignSystem": "Design System",
  "marketplace.prompts.catIntegrations": "Integrations",
  "marketplace.prompts.catMigration": "Migration",
  "marketplace.prompts.catPages": "Pages",
  "marketplace.prompts.catRefactoring": "Refactoring",
  "marketplace.prompts.cmpButtonVariants.tagline": "Primary / secondary / ghost variants in v3.14 syntax.",
  "marketplace.prompts.cmpButtonVariants.title": "Button with variants",
  "marketplace.prompts.cmpCardCollection.tagline": "children + childExtends pattern (no $collection).",
  "marketplace.prompts.cmpCardCollection.title": "Card grid from data",
  "marketplace.prompts.cmpModal.tagline": "Esc-to-close, focus trap, design tokens only.",
  "marketplace.prompts.cmpModal.title": "Modal with backdrop",
  "marketplace.prompts.dbgBlankRender.tagline": "Most common cause: leftover el.props / el.on access after migration.",
  "marketplace.prompts.dbgBlankRender.title": "Component renders blank in v3.14",
  "marketplace.prompts.dbgIframeLeak.tagline": "Scratch singleton bleed — isolate via context.designSystem.",
  "marketplace.prompts.dbgIframeLeak.title": "Canvas iframe sharing design system with parent",
  "marketplace.prompts.dsAudit.tagline": "Strip raw px / hex / Tailwind palettes; report violations.",
  "marketplace.prompts.dsAudit.title": "Audit a component for token compliance",
  "marketplace.prompts.dsDarkMode.tagline": "Per-component @dark variants without raw selectors.",
  "marketplace.prompts.dsDarkMode.title": "Dark / light theme switch",
  "marketplace.prompts.dsThemeExtend.tagline": "Add a new color, type ramp step, or spacing token cleanly.",
  "marketplace.prompts.dsThemeExtend.title": "Extend the design system",
  "marketplace.prompts.emptyHint": "Switch to All to see every prompt.",
  "marketplace.prompts.emptyTitle": "No prompts in this category yet",
  "marketplace.prompts.eyebrow": "Prompt Gallery",
  "marketplace.prompts.intInstallRail.tagline": "Drop a workspace integration rail into any page.",
  "marketplace.prompts.intInstallRail.title": "Mount InstallableRail in a project",
  "marketplace.prompts.intOpenid.tagline": "Register a kind, add post-install hook, expose to MarketplaceCard.",
  "marketplace.prompts.intOpenid.title": "Wire an OAuth integration",
  "marketplace.prompts.migReactToDomql.tagline": "JSX, useState, hooks → plain object component + state model.",
  "marketplace.prompts.migReactToDomql.title": "Convert React → DOMQL",
  "marketplace.prompts.migV3V314.tagline": "el.props.X → el.X, on.click → onClick, attr → flat props.",
  "marketplace.prompts.migV3V314.title": "Migrate v3 → v3.14 syntax",
  "marketplace.prompts.pgDashboard.tagline": "AppShell + AppSidebar + AppMain composition.",
  "marketplace.prompts.pgDashboard.title": "Dashboard page scaffold",
  "marketplace.prompts.pgEmptyState.tagline": "Onboarding-grade empty page with illustration and primary action.",
  "marketplace.prompts.pgEmptyState.title": "Empty state with CTA",
  "marketplace.prompts.pgSettings.tagline": "Tabbed sub-routes, form fields, save bar.",
  "marketplace.prompts.pgSettings.title": "Settings page with sections",
  "marketplace.prompts.rfExtractComponent.tagline": "Promote inline keys to a project-level component with PascalCase.",
  "marketplace.prompts.rfExtractComponent.title": "Extract a sub-tree into a registered component",
  "marketplace.prompts.rfSharedLibrary.tagline": "Move a duplicated component into shared/ with the right export shape.",
  "marketplace.prompts.rfSharedLibrary.title": "Promote a component to shared library",
  "marketplace.prompts.subtitle": "Curated, copy-ready prompts for building, migrating, and debugging DOMQL v3.14 components, pages, and design systems. Tap any card to copy the full prompt — paste it into Claude, the Symbols MCP, or the editor’s AI tab.",
  "marketplace.prompts.title": "Prompts that work for Symbols projects",
  "marketplace.prompts.resultsAll": "{count} prompts · all categories",
  "marketplace.prompts.resultsAllOne": "1 prompt · all categories",
  "marketplace.prompts.resultsFiltered": "{shown} of {total} prompts · {category}",
  "marketplace.railDemo.emptyHint": "A \"library\" domain with no data pre-populated — shows InstallableRailEmpty.",
  "marketplace.railDemo.emptyTitle": "Empty state (no kinds)",
  "marketplace.railDemo.gridHint": "Responsive auto-fill card grid. Same data source as the rail above.",
  "marketplace.railDemo.integrationsHeading": "Integrations",
  "marketplace.railDemo.librariesHeading": "Libraries",
  "marketplace.railDemo.listHint": "Bordered vertical management list with chevron + status badges.",
  "marketplace.railDemo.mcpHeading": "MCP Connectors",
  "marketplace.railDemo.mcpHint": "MCP connectors — none installed. Shows \"Available\" badge on all.",
  "marketplace.railDemo.railHint": "Horizontal scrolling chip row. Two items pre-installed (GitHub, Slack).",
  "marketplace.railDemo.subtitle": "Exercises all three layout variants (rail / grid / list). Clicks open the Phase 3 InstallableModalStub stub modal — Phase 4 MarketplaceInstallModal will replace it.",
  "marketplace.railDemo.taglineFigma": "Import design tokens automatically.",
  "marketplace.railDemo.taglineFilesystem": "Read and write local files via MCP.",
  "marketplace.railDemo.taglineGithub": "Connect your repositories.",
  "marketplace.railDemo.taglineGithubMcp": "Manage repos and PRs via MCP.",
  "marketplace.railDemo.taglineLinear": "Sync issues and milestones.",
  "marketplace.railDemo.taglineNotion": "Publish docs from your workspace.",
  "marketplace.railDemo.taglinePostgres": "Query Postgres databases via MCP.",
  "marketplace.railDemo.taglineSlack": "Send notifications to channels.",
  "marketplace.railDemo.title": "InstallableRail Demo",
  "marketplace.railNav.next": "Scroll forward",
  "marketplace.railNav.nextAria": "Next",
  "marketplace.railNav.prev": "Scroll back",
  "marketplace.railNav.prevAria": "Previous",
  "marketplace.resources.actionCopy": "Copy",
  "marketplace.resources.actionInstall": "Install",
  "marketplace.resources.actionUse": "Use",
  "marketplace.resources.agentsTitle": "Agents",
  "marketplace.resources.copiedPrompt": "Copied \"{name}\" prompt",
  "marketplace.resources.countAgents": "{count} agents",
  "marketplace.resources.countAgentsOne": "1 agent",
  "marketplace.resources.countPrompts": "{count} prompts",
  "marketplace.resources.countPromptsOne": "1 prompt",
  "marketplace.resources.countSkills": "{count} skills",
  "marketplace.resources.countSkillsOne": "1 skill",
  "marketplace.resources.promptsTitle": "Prompts",
  "marketplace.resources.seeAll": "See All ›",
  "marketplace.resources.skillsTitle": "Skills",
  "marketplace.results.filtered": "{visible} of {total} items",
  "marketplace.results.filteredOne": "{visible} of 1 item",
  "marketplace.results.items": "{count} items",
  "marketplace.results.itemsOne": "1 item",
  "marketplace.resultsBar.title": "All results",
  "marketplace.scope.attachToOrg": "Attach to organization",
  "marketplace.scope.attachToProject": "Attach to project",
  "marketplace.scope.attachToWorkspace": "Attach to workspace",
  "marketplace.scope.connectAt": "Connect at {scope}",
  "marketplace.scope.connectAtOrg": "Connect at organization",
  "marketplace.scope.connectAtProject": "Connect at project",
  "marketplace.scope.connectAtWorkspace": "Connect at workspace",
  "marketplace.scope.forkIntoProject": "Fork into a new project",
  "marketplace.scope.installToWorkspace": "Install to workspace",
  "marketplace.search.clear": "Clear search",
  "marketplace.search.placeholder": "Search…",
  "marketplace.shortcuts.close": "Close this help, then detail pane",
  "marketplace.shortcuts.closeHint": "Press Esc or ? to close.",
  "marketplace.shortcuts.copyUrl": "Copy shareable URL to clipboard",
  "marketplace.shortcuts.focusSearch": "Focus search",
  "marketplace.shortcuts.installItem": "Install / Configure open item",
  "marketplace.shortcuts.moveCards": "Move between cards",
  "marketplace.shortcuts.openItem": "Open focused item",
  "marketplace.shortcuts.random": "Surprise me — open a random visible item",
  "marketplace.shortcuts.title": "Keyboard shortcuts",
  "marketplace.shortcuts.toggleHelp": "Toggle this help",
  "marketplace.shortcuts.togglePin": "Toggle pin on open detail",
  "marketplace.signin.checkCredentials": "Please check your credentials and try again.",
  "marketplace.signin.failed": "Sign-in failed.",
  "marketplace.signin.failedTitle": "Failed to sign in",
  "marketplace.signin.missingMessage": "Email/username and password are required.",
  "marketplace.signin.missingTitle": "Missing fields",
  "marketplace.tabs.appStore": "App Store",
  "marketplace.tabs.aria": "Marketplace surface",
  "marketplace.tabs.integrations": "Integrations",
  "marketplace.tabs.market": "Marketplace",
  "marketplace.tile.pin": "Pin to sidebar",
  "marketplace.tile.pinAria": "Toggle pin",
  "marketplace.toast.installed": "Installed {name}",
  "marketplace.toast.installedPlus": "Installed {name} + {count} apps",
  "marketplace.toast.installedPlusOne": "Installed {name} + 1 app",
  "marketplace.toast.removed": "Removed {name}",
  "marketplace.toast.undo": "Undo",
  "marketplace.toast.appInstalled": "App installed — live on the workspace",
  "marketplace.uninstallDeps.cancel": "Cancel",
  "marketplace.uninstallDeps.forceRemove": "Force remove — may break {count} apps",
  "marketplace.uninstallDeps.forceRemoveOne": "Force remove — may break 1 app",
  "marketplace.uninstallDeps.hint": "{count} installed apps still require {name} to work.",
  "marketplace.uninstallDeps.hintOne": "1 installed app still requires {name} to work.",
  "marketplace.uninstallDeps.hintPlain": "{name} still has installed apps depending on it.",
  "marketplace.uninstallDeps.optionalSection": "Uses this app optionally — would just lose a feature",
  "marketplace.uninstallDeps.removing": "Removing…",
  "marketplace.uninstallDeps.requiredSection": "Requires this app — blocks removal",
  "marketplace.uninstallDeps.thisApp": "this app",
  "marketplace.uninstallDeps.title": "Can't remove {name}",
  "marketplace.follow.follow": "Follow",
  "marketplace.follow.following": "Following",
  "marketplace.feedSeed.communityAuthorName": "Community",
  "marketplace.feed.anonymous": "Anonymous"
}
